import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-vehicleCategory",
  "use": "icon-vehicleCategory-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vehicleCategory\"><path fill=\"currentColor\" d=\"M896 576h-64l-64-192H576v-64H256L128 448v256h64a96 96 0 0 0 192 0h256a96 96 0 0 0 192 0h64v-128zM288 736a48 48 0 1 1 0-96 48 48 0 0 1 0 96zM736 736a48 48 0 1 1 0-96 48 48 0 0 1 0 96zM576 384h128l53 160H576v-160zM224 464l64-64h160v160H192l32-96zM224 256h448v64H224zM224 160h320v64H224z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/vehicleCategory.svg
// module id = MZxh
// module chunks = 102